export const FIVEFIVE_MAPS = [
  { name: 'Acropolis',        slug: 'acropolis',        file: 'Acropolis.png' },
  { name: 'Agora',            slug: 'agora',            file: 'Agora.png' },
  { name: 'Artifact X',       slug: 'artifact-x',       file: 'Artifact X.png' },
  { name: 'Backalley',        slug: 'backalley',        file: 'Backalley.png' },
  { name: 'Beatdown Club',    slug: 'beatdown-club',    file: 'Beatdown club.png' },
  { name: 'Central Station',  slug: 'central-station',  file: 'Central station.png' },
  { name: 'Colonnade',        slug: 'colonnade',        file: 'Colonnade.png' },
  { name: 'Constant',         slug: 'constant',         file: 'Constant.png' },
  { name: 'Container City',   slug: 'container-city',   file: 'Container city.png' },
  { name: 'Crane Yard',       slug: 'crane-yard',       file: 'Crane yard.png' },
  { name: 'Crimson Works',    slug: 'crimson-works',    file: 'Crimson works.png' },
  { name: 'Dockyard',         slug: 'dockyard',         file: 'Dockyard.png' },
  { name: 'EQuilibrium',      slug: 'equilibrium',      file: 'Equilibrium.png' },
  { name: 'Fortune Towers',   slug: 'fortune-towers',   file: 'Fortune towers.png' },
  { name: 'Freight Depot',    slug: 'freight-depot',    file: 'Freight depot.png' },
  { name: 'Frost Rink',       slug: 'frost-rink',       file: 'Frost rink.png' },
  { name: 'Ground Zero',      slug: 'ground-zero',      file: 'Ground zero.png' },
  { name: 'Hanging Gardens',  slug: 'hanging-gardens',  file: 'Hanging gardens.png' },
  { name: 'High Bridge',      slug: 'high-bridge',      file: 'High bridge.png' },
  { name: 'Hope Launchpad',   slug: 'hope-launchpad',   file: 'Hope launchpad.png' },
  { name: 'Imperial Temple',  slug: 'imperial-temple',  file: 'Imperial temple.png' },
  { name: 'Nebula Square',    slug: 'nebula-square',    file: 'Nebula sQuare.png' },
  { name: 'Neon Central',     slug: 'neon-central',     file: 'Neon central.png' },
  { name: 'Paradise Plaza',   slug: 'paradise-plaza',   file: 'Paradise plaza.png' },
  { name: 'Powder Parkway',   slug: 'powder-parkway',   file: 'Powder parkway.png' },
  { name: 'Shevchenko Park',  slug: 'shevchenko-park',  file: 'Shevchenko park.png' },
  { name: 'Singularity',      slug: 'singularity',      file: 'Singularity.png' },
  { name: 'Skyship 11',       slug: 'skyship-11',       file: 'Skyship 11.png' },
  { name: 'Snowdrift Stage',  slug: 'snowdrift-stage',  file: 'Snowdrift stage.png' },
  { name: 'The Stacks',       slug: 'the-stacks',       file: 'The stacks.png' },
  { name: 'Tunnel of Fate',   slug: 'tunnel-of-fate',   file: 'Tunnel of fate.png' },
  { name: 'Two Arches',       slug: 'two-arches',       file: 'Two arches.png' },
  { name: 'VMD Lab',          slug: 'vmd-lab',          file: 'VMD lab.png' },
  { name: 'ZC Cargo Dock',    slug: 'zc-cargo-dock',    file: 'Z C Cargo dock.png' },
  { name: 'ZC Control',       slug: 'zc-control',       file: 'Z C control.png' },
  { name: 'ZC Shop Floor',    slug: 'zc-shop-floor',    file: 'Z C shop floor.png' },
];
